// src/components/pdf-viewer/PageNumber.js
import React from 'react';

/**
 * Format page number with 6-digit zero padding (e.g., 1 -> "000001")
 * Matches the bates number format used in the index and export
 */
const formatPageNumber = (pageNum) => {
  return pageNum.toString().padStart(6, '0');
};

/**
 * PageNumber Component - Static page number overlay for PDF viewer
 * Positioned at bottom center to match export
 * Scales with PDF display using the same scaling as the stamp
 * 
 * @param {number} pageNumber - The absolute page number in the merged document (1-based)
 * @param {number} pdfScale - Scale factor for the PDF display (displayHeight / actualHeight)
 */
const PageNumber = ({ pageNumber, pdfScale = 1 }) => {
  const formattedNumber = formatPageNumber(pageNumber);
  
  // Base dimensions in PDF points (matching export)
  const BASE_FONT_SIZE = 10; // 10pt
  const BASE_MARGIN_BOTTOM = 36; // 0.5 inches = 36 points
  
  return (
    <div
      className="page-number-overlay"
      style={{
        position: 'absolute',
        bottom: `${BASE_MARGIN_BOTTOM * pdfScale}px`, // Scale the margin
        left: '50%',
        transform: 'translateX(-50%)', // Center horizontally
        pointerEvents: 'none', // Don't interfere with interactions
        userSelect: 'none',
        fontFamily: 'Times New Roman, serif',
        fontSize: `${BASE_FONT_SIZE * pdfScale}px`, // Scale the font size
        color: '#000000',
        backgroundColor: 'transparent',
        zIndex: 10, // Above PDF content
      }}
    >
      {formattedNumber}
    </div>
  );
};

export default PageNumber;